<template lang="pug">
  v-dialog(v-model='state.dialog' width='800')
    template(v-slot:activator='{ on }')
      v-btn(color='primary' v-on='on') Añadir saldo inicial
    v-card
      v-form(autocomplete='false' v-model='valid')
        v-toolbar(dark color='primary')
            h2 Registro de Saldo Inicial
            v-spacer
            v-btn(icon dark @click='cerrar()')
                v-icon fas fa-times
        v-container(grid-list-md)
            v-row
                v-col(align-content-end).xs4.pa-1
                    v-text-field(:rules='[rules.required]' type='number' label='Monto' v-model='state.cantidad')
                v-col(align-content-end).xs4.pa-1
                    v-autocomplete(:rules='[rules.required]' v-model='state.debe' label='Debe' :items='registro_partidas_contables' :item-text='item=>item.codigo+"/"+item.descripcion' :item-value='item=>item.codigo')    
                v-col(align-content-end).xs4.pa-1
                    v-autocomplete(:rules='[rules.required]' v-model='state.haber' label='Haber' :items='registro_partidas_contables' :item-text='item=>item.codigo+"/"+item.descripcion' :item-value='item=>item.codigo')
            v-spacer
            v-row
                v-flex.xs5.pa-1
                v-spacer
                    v-btn(color='primary' @click='(valid) ? add() : null' v-html='"Pagar"' :disabled='(valid) ? false : true')  

</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { getPeriod } from '@/Helper.js'
export default {
    data: ()=>({
        valid: true
    }),
    methods: {
        ...mapActions({
            add: 'Saldo_inicial/add',
            cerrar: 'Saldo_inicial/cleanForm'
        }),    
    },
    computed: {
        ...mapState({
            rules: state=>state.Helpers.rules,
            state: state=>state.Saldo_inicial
        }),
        ...mapGetters({
            registro_partidas_contables: 'Partidas_Contables/record',
        }),
    }
}
</script>

